import { render } from "./lohana-community-history.vue?vue&type=template&id=5ecdd623&scoped=true"
import script from "./lohana-community-history.vue?vue&type=script&lang=js"
export * from "./lohana-community-history.vue?vue&type=script&lang=js"

import "./lohana-community-history.vue?vue&type=style&index=0&id=5ecdd623&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ecdd623"]])

export default __exports__